export default __webpack_public_path__ + "static/media/Cheeky.9ed8e1d3.gif";